import instance from "../interceptors/AxiosInterceptor";

const BASE_URL = "/api/settlements";
const settlementService = {

    getSettlements: async (contractId) => {
        try {
            const response = await instance.get(`${BASE_URL}/all/${contractId}`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    addSettlement: async (contractId, settlement) => {
        try {
            const response = await instance.post(`${BASE_URL}/add/${contractId}`, settlement, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updateSettlement: async (settlementId, settlement) => {
        try {
            const response = await instance.post(`${BASE_URL}/update/${settlementId}`, settlement, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    deleteSettlement: async (settlementId) => {
        try {
            const response = await instance.delete(`${BASE_URL}/delete/${settlementId}`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

}

export default settlementService;